import { Component } from "@angular/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { EventsService } from "./services/event/event.service";
import { Platform } from "@ionic/angular";
import { ConfigService } from "./services/config/config.service";
import { toBoolean } from "./services/codeUtils";
import { Navigator } from 'src/app/components/menu/navigator';
import { Subscription } from "rxjs";
import { OverlayService } from "./services/overlay/overlay.service";
import { App } from "@capacitor/app";
import { AudioService } from "./services/audio/audio.service";
import { NavigationStart, Router } from "@angular/router";
import { checkRedirectLoggedInRoutesName, checkRedirectLoggedOutRoutesName } from "./components/menu/factory";
import { SocialAuthService } from "./services/authentication/social-auth.service";
import { PushNotifications } from "@capacitor/push-notifications";
import { NotificationHandlerService } from "./services/notification-handler/notification-handler.service";

declare var window: any;
declare var cordova: any;


@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  public showLobby: boolean = true;
  public suspendNotifications: boolean = false;
  public isMobileApp = false;
  public showHideFooter: boolean = true;
  public showOverlay = false;
  private subscription: Subscription;
  public collectUserInfo: boolean = false;
  public isEnvSelector: boolean  = this.platform.is('capacitor');
  public hasNotificationPermissionPrompted: boolean = false;
  public csrf;
  protected appInactivityFlag: boolean = toBoolean(this.config?.getConfig()?.FEATURE_APP_INACTIVITY) ?? false;
  protected mainBgrImagePath: string = this.config?.getConfig()?.IMAGEPATH_MAIN_BGR ?? 'imgs/mainbgr.png';

  constructor(
    private readonly socialAuth: SocialAuthService,
    public navigator: Navigator,
    private events: EventsService,
    private platform: Platform,
    private config: ConfigService,
    private overlayService: OverlayService,
    private router: Router,
    private audioService: AudioService,
    private notificationHandler: NotificationHandlerService,
  ) {
    this.isMobileApp = this.platform.is('capacitor');
    this.socialAuth.socialAuthInit();

    //-----------Browser back/forward button logic for game Launcher only start------------
    //This logic will make sure user can go back to Casino Lobby from Game window
    //but, cannot access game window from browser back/forward click
    //so, we maintain casino path history for simplicity
    if (!this.isMobileApp) {
      this.hasNotificationPermissionPrompted = true;
      router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
            let browserURLPath = event.url;
            let authCheckForUser: boolean;
            if (localStorage.getItem('userSession.sessionToken') !== null) {
              authCheckForUser = true;
            } else {
              authCheckForUser = false;
            }
            //Fake Check for Launcher path since we're only doing router for Casino
            if (browserURLPath != "/") {
              let cleanPath = browserURLPath.substring(1);
              let pageToLoad;
              if (authCheckForUser) {
                pageToLoad = checkRedirectLoggedInRoutesName(cleanPath);
                if (!!pageToLoad) return this.navigator.navigateTo(pageToLoad);
                return this.router.navigate(['/casino'], { skipLocationChange: false });
              } else {
                pageToLoad = checkRedirectLoggedOutRoutesName(cleanPath);
                if (!!pageToLoad) return this.navigator.navigateTo(pageToLoad);
                return this.router.navigate(['/casino'], { skipLocationChange: false });
              }
            }
          }
        }
      });
    }
    else {
      this.requestNotificationPermission();
    }
    //-----------Browser back/forward button logic for game Launcher only End------------
  }
  async requestNotificationPermission(){
    await PushNotifications.requestPermissions();
    await PushNotifications.register();
    this.hasNotificationPermissionPrompted = true;
  }
  ngOnInit() {

    //Cookie Consent
    if(!this.isMobileApp)this.addCookieManangement();
    
    const params = new URLSearchParams(document.location.search).toString();

    if (params) {
      var canonicalTag = document.createElement('link');
      canonicalTag.rel = 'canonical';
      canonicalTag.href = document.location.origin + document.location.pathname;

      document.head.appendChild(canonicalTag);
    }

    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
      this.events.publish('event:appStateChange', isActive);
      this.audioService.isAppActive = isActive;

      if (isActive) {
        this.audioService.playMusic("BGMusic");
      }
      else {
        this.audioService.stopMusic();
      }
    });

    this.config.isLoaded().then(() => {
      SplashScreen.hide();
    });

    //Welcome Dialog Listner
    this.events.subscribe('show:welcome:dialog', () => {
      this.overlaySubcriber();
    })

    this.events.subscribe("event:bottomfooter:hide", () => {
      this.showHideFooter = false;
    });

    this.events.subscribe("event:bottomfooter:show", () => {
      this.showHideFooter = true;
    });

    this.events.subscribe("event:lobby:hide", () => {
      this.showLobby = false;
    });

    this.events.subscribe("event:lobby:show", () => {
      this.showLobby = true;
    });

    this.events.subscribe("event:notification:suspend", () => {
      this.suspendNotifications = true;
    });

    this.events.subscribe("event:notification:resume", () => {
      this.suspendNotifications = false;
    });

    this.events.subscribe("event:remove:env:selector", () => {
      this.isEnvSelector = false;
      if(this.platform.is('capacitor')) {
        SplashScreen.hide();
      }
      //Need to revisit logic as we need to also check Location Check to prevent player to access the app from certain state like Washington
      //this.autoCloseSplash();
    });

    this.events.subscribe('event:remove:splash', () => {
      this.collectUserInfo = true;
    });

    const pushNotificationReload = this.events.subscribe('event:push-notification:reload', () => {
      console.log("pushNotificationReload called");
      this.hasNotificationPermissionPrompted = false;
      setTimeout(() => {
        console.log("pushNotificationReload setTimeout");
        this.hasNotificationPermissionPrompted = true;
        pushNotificationReload.unsubscribe();
      }, 1000);
    });

    if(!this.isEnvSelector){
      //Need to revisit logic as we need to also check Location Check to prevent player to access the app from certain state like Washington
      //this.autoCloseSplash();

    }

    //Special Check added for Forgot Password so, it won't goes to launch-check component
    let url = document.location.href;
    if ((url.indexOf('#password_reset') > -1) || (url.indexOf('#password_forgot') > -1)) {
      this.collectUserInfo = true
    }

    if (url.indexOf('redirect') > -1) {
      const urlParams = new URLSearchParams(window.location.search);  // Extract the query string

      // Get the promo_code from the URL
      const promoCode = urlParams.get('promo_code');

      // Ensure promoCode is not null
      if (promoCode) {
        this.notificationHandler.isNotificationHalted = true;
        this.notificationHandler.isSplashScreenFinished$.subscribe((isFinished) => {
          if(isFinished) {
            setTimeout(() => {
              this.events.publish('event:redeem:promo', promoCode);
            }, 1000);
          }
        });
      } else {
        console.warn('Promo code is missing from the URL.');
      }

    }

  }

  autoCloseSplash(){
    setTimeout(() => {
      if (!this.collectUserInfo) {
        console.warn('Splash screen event did not occur, removing after timeout.');
        this.collectUserInfo=true;
      }
    }, 10000);

  }

  overlaySubcriber(){
    if(this.subscription){
      try{
      this.subscription.unsubscribe()
      }catch(e){
        console.log("Error",e)
      }
    }
    this.subscription = this.overlayService.context$.subscribe(
      (context) => {
        this.showOverlay = context.display;
        if (context.display) {
          setTimeout(() => {
            this.overlayService.hide();
            //if(context.componentCall){
              //context.componentCall();
            //}
          }, 5000);
        }
      }
    );
  }

  mainMenuClosed() {
    this.events.publish("hide:balanceSection");
  }

  mainMenuOpened() {
    this.events.publish('menuopen');
  }

  addCookieManangement() {
    let onetrust_url = this.config.getConfig().FEATURE_ONETRUST_URL;
    let onetrust_domain = this.config.getConfig().FEATURE_ONETRUST_DATA;
    if (onetrust_url && onetrust_domain) {
      const scriptFirst = document.createElement("script");
      scriptFirst.setAttribute("type", "text/javascript");
      scriptFirst.setAttribute("charset", "UTF-8");
      scriptFirst.setAttribute("src", onetrust_url);
      scriptFirst.setAttribute("data-domain-script", onetrust_domain);
      document.head.appendChild(scriptFirst);

      const scriptSecond = document.createElement('script');
      scriptSecond.setAttribute("type", "text/javascript");
      scriptSecond.innerHTML = `function OptanonWrapper() { }`;
      document.head.appendChild(scriptSecond);
    }
  }

  ngOnDestroy() {
    try{
    this.subscription.unsubscribe();
    }catch(e){
      console.log("Error",e)
    }
  }

}
